<app-tabla
  [totalCount]="totalCount()"
  [datos]="sirenas"
  [columnas]="columnas"
  [name]="name"
  [pageSizeOptions]="helper.pageSizeOptions"
  [search]="search"
  [(query)]="query"
  (queryChange)="listar()"
  [paginatorArriba]="false"
  [crear]="botonSync"
  [exportar]="botonServicioTecnicoMasivo"
  [filtros]="filtros"
  [emptyState]="{ title: 'Todavía no hay sirenas' }"
></app-tabla>
